import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950" data-testid="protected-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#0F2942]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (roles && !roles.includes(user.role) && user.role !== "super_admin") {
    return <Navigate to={user.role === "citizen" ? "/portal" : "/dashboard"} replace />;
  }
  return children;
}
